<template>
    <v-main fluid>
        <v-container class="p-0 px-2">
            <v-row class="d-flex justify-content-center">
                <v-col cols="12" sm="10" md="7" lg="5">
                    <div class="bg-white border p-5">
                        <div v-if="phase == 'request'">
                            <h1 class="display-3">{{$t("Login")}}</h1>
                            <hr />
                            {{$t("EmailAdress")}}
                            <v-text-field id="email"
                                          ref="email"
                                          autocomplete="username"
                                          v-model="model.email"
                                          v-bind:error="errors.email"
                                          dense
                                          outlined
                                          hide-details
                                          color="primary"
                                          append-icon="email"
                                          v-bind:placeholder="$t('EmailAdress')"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          class="mb-3"></v-text-field>

                            {{$t("Password")}}
                            <v-text-field id="password"
                                          ref="password"
                                          autocomplete="new-password"
                                          v-model="model.password"
                                          v-bind:error="errors.password"
                                          dense
                                          outlined
                                          hide-details
                                          color="primary"
                                          v-bind:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
                                          v-on:click:append="showpassword = !showpassword"
                                          v-bind:type="showpassword ? 'text' : 'password'"
                                          v-bind:placeholder="$t('Password')"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          class="mb-3"></v-text-field>

                            <v-row class="my-3 d-flex justify-content-center align-items-center">
                                <v-col cols="auto" class="mr-0 pr-0">
                                    <v-skeleton-loader v-if="captchaUrl.length == 0"
                                                       max-width="240"
                                                       max-height="70"
                                                       min-width="240"
                                                       min-height="70"
                                                       type="image"></v-skeleton-loader>
                                    <img v-else
                                         alt="Captcha"
                                         v-bind:src="captchaUrl"
                                         width="240"
                                         height="70"
                                         v-bind:style="{ 'filter' : 'blur(' + (captchaBlur ? '5px' : '0px') + ')'}" />
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn depressed icon v-on:click="ReloadCaptcha()" color="primary">
                                        <v-icon>{{ captchaBlur ? 'mdi-eye' : 'cached'}}</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            {{$t("SecurityCode")}}
                            <v-text-field v-model="model.captcha"
                                          v-bind:error="errors.captcha"
                                          dense
                                          outlined
                                          hide-details
                                          color="primary"
                                          append-icon="mdi-shield-check"
                                          v-bind:placeholder="$t('SecurityCode')"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          class="mb-5"></v-text-field>

                            <v-row>
                                <v-col cols="12" class="mt-5">
                                    <table>
                                        <tr v-for="(document, i) in documents" v-bind:key="i" class="my-0 py-0 d-flex align-center ">
                                            <td class="d-flex align-center my-0 py-0">
                                                <v-checkbox v-model="document.selected" v-bind:error="document.error" color="primary" class="my-0 py-0">
                                                    <template v-slot:prepend>
                                                        <v-btn color="primary" icon v-on:click="OpenAccountDocument(document.title)">
                                                            <v-icon>mdi-file-document-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <template v-slot:label>
                                                        <span class="body-2" style="padding-top: 10px">{{$t(document.title + 'Description')}}</span>
                                                    </template>
                                                </v-checkbox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p class="caption" v-html="$t('RusvetVeYolsuzluklaMucadeleDescription')"></p>
                                            </td>
                                        </tr>
                                    </table>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else-if="phase == 'changePassword'">
                            <h1 class="display-3">{{$t("AL_ChangePassword")}}</h1>
                            <hr />
                            <v-alert text color="primary" icon="mdi-information-outline">{{$t("PasswordExpired")}}</v-alert>

                            <v-text-field id="oldpassword"
                                          ref="oldpassword"
                                          autocomplete="off"
                                          v-model="model.oldpassword"
                                          v-bind:error="errors.oldpassword"
                                          dense
                                          outlined
                                          hide-details
                                          color="secondary"
                                          v-bind:append-icon="oldShowpassword ? 'mdi-eye' : 'mdi-eye-off'"
                                          v-on:click:append="oldShowpassword = !oldShowpassword"
                                          v-bind:type="oldShowpassword ? 'text' : 'password'"
                                          v-bind:placeholder="$t('FL_Password')"
                                          :label="$t('FL_Password')"
                                          class="mb-3"></v-text-field>

                            <v-text-field id="newpassword1"
                                          ref="newpassword1"
                                          autocomplete="off"
                                          v-model="modelnewpassword1"
                                          v-bind:error="errors.newpassword1"
                                          dense
                                          outlined
                                          hide-details
                                          color="secondary"
                                          v-bind:append-icon="newShowpassword ? 'mdi-eye' : 'mdi-eye-off'"
                                          v-on:click:append="newShowpassword = !newShowpassword"
                                          v-bind:type="newShowpassword ? 'text' : 'password'"
                                          v-bind:placeholder="$t('FL_newpassword1')"
                                          v-on:focus="SetSnackbar('newpassword1', 1)"
                                          v-on:focusout="SetSnackbar('newpassword1', 0)"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          :label="$t('FL_newpassword1')"
                                          class="mb-3"></v-text-field>
                            <v-list dense v-show="snackbar.newpassword1">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title style="text-transform: capitalize" v-for="(item, i) in PassRequirementsMessages.newpassword1" v-bind:key="i" v-bind:class="item.satisfy ? 'green--text' : 'red--text'">
                                            <v-icon left v-bind:class="item.satisfy ? 'green--text' : 'red--text'">
                                                {{item.satisfy ? 'mdi-check' : 'mdi-close'}}
                                            </v-icon>
                                            {{$t(item.text)}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>

                            <v-text-field id="newpassword2"
                                          ref="newpassword2"
                                          autocomplete="off"
                                          v-model="modelnewpassword2"
                                          v-bind:error="errors.newpassword2"
                                          dense
                                          outlined
                                          hide-details
                                          color="secondary"
                                          v-bind:append-icon="newShowpasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                          v-on:click:append="newShowpasswordConfirm = !newShowpasswordConfirm"
                                          v-bind:type="newShowpasswordConfirm ? 'text' : 'password'"
                                          v-bind:placeholder="$t('FL_newpassword2')"
                                          v-on:focus="SetSnackbar('newpassword2', 1)"
                                          v-on:focusout="SetSnackbar('newpassword2', 0)"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          :label="$t('FL_newpassword2')"
                                          class="mb-3"></v-text-field>
                            <div class="pt-1" v-show="snackbar.newpassword2">
                                <v-list dense>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title style="text-transform: capitalize" v-for="(item, i) in PassRequirementsMessages.newpassword2" v-bind:key="i" v-bind:class="item.satisfy ? 'green--text' : 'red--text'">
                                                <v-icon left v-bind:class="item.satisfy ? 'green--text' : 'red--text'">
                                                    {{item.satisfy ? 'mdi-check' : 'mdi-close'}}
                                                </v-icon>
                                                {{$t(item.text)}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </div>

                        </div>
                        <div v-else>
                            <h1 class="display-3">{{$t("LoginVerification")}}</h1>
                            <hr />
                            <v-alert text color="primary" icon="mdi-information-outline">{{$t('SMSSentToYourPhoneContactDepartmentIfYouThinkItsWrong', { 0: phonecode, 1: maskedphonenumber })}}</v-alert>
                            <v-alert v-show="timerremaining == 0" text color="red" icon="mdi-clock-outline">{{$t("CodeExpiredSendNewCodeRequest")}}</v-alert>
                            <v-alert v-show="timerremaining > 0" text color="primary" icon="mdi-clock-outline">{{$t("CodeIsValidForXSecond")}}: {{timerremaining}} {{$t("Second")}}</v-alert>
                            {{$t("VerificationCode")}}
                            <v-text-field v-model="model.verificationcode"
                                          v-bind:error="errors.verificationcode"
                                          v-bind:disabled="timerremaining == 0"
                                          dense
                                          outlined
                                          hide-details
                                          color="primary"
                                          append-icon="dialpad"
                                          v-bind:placeholder="$t('VerificationCode')"
                                          v-on:keyup.enter="OnDefaultEnter"
                                          class="mb-3"></v-text-field>

                        </div>

                        <v-btn v-if="phase == 'request'" v-bind:disabled="LoginRequestButtonDisableState" depressed block color="primary white--text" v-on:click="Login_Request()">{{$t('Login')}}</v-btn>
                        <v-btn v-else-if="phase == 'changePassword'" v-bind:disabled="ChangePasswordButtonDisableState" depressed block color="primary white--text" v-on:click="Login_Change_Password()">{{$t('AL_ChangePassword')}}</v-btn>
                        <div v-else>
                            <v-btn v-if="timerremaining == 0" v-bind:disabled="processing" depressed block color="primary white--text" v-on:click="Login_Send_OTP()">{{$t('Resend')}}</v-btn>
                            <v-btn v-else v-bind:disabled="processing" depressed block color="primary white--text" v-on:click="Login_Verification()">{{$t('Verify')}}</v-btn>
                        </div>

                        <hr />

                        <p><router-link to="/Account/Register">{{$t("Register")}}</router-link></p>
                        <p><router-link to="/Account/Forgot">{{$t("ForgotPassword")}}</router-link></p>
                        <p><router-link to="/Account/Application">{{$t("Applicationform")}}</router-link></p>
                    </div>
                    <v-progress-linear v-if="processing" color="primary" indeterminate></v-progress-linear>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="showErrorPopup" width="390">
            <v-card class="mx-auto pt-7 pb-2">
                <alertIcon icon="warning"></alertIcon>
                <v-card-title>
                    <p class="headline">{{$t("Warning")}}</p>
                </v-card-title>
                <v-card-text>
                    <p
                       v-for="(message, i) in errorMessages" v-bind:key="i" class="mb-0" style="white-space: pre-line;">{{message}}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="warning" block v-on:click="ClearErrors(true)">
                        {{$t("Ok")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="processing" persistent>
            <v-card color="transparent" dark class="py-5">
                <v-card-text class="text-center py-5">
                    <v-progress-circular indeterminate
                                         :size="50"
                                         color="white"></v-progress-circular>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-main>
</template>

<style>
    .v-dialog {
        box-shadow: none !important;
    }
</style>

<script>
    import axios from 'axios';
    import { FormMixIn } from '@/MixIns/FormMixins';

    export default {
        name: "Login",
        mixins: [FormMixIn],
        data: function ()
        {
            return {
                accesskey: '',
                phase: 'request',
                phaseHash: 'request',

                processing: false,

                eventid: '',
                phonecode: '',
                maskedphonenumber: '',

                model: {
                    email: '',
                    password: '',
                    verificationcode: '',
                    captcha: '',
                    oldpassword: '',
                    newpassword1: '',
                    newpassword2: '',
                },

                errors: {
                    email: false,
                    password: false,
                    verificationcode: false,
                    captcha: false,
                    oldpassword: false,
                    newpassword1: false,
                    newpassword2: false,
                },

                errorMessages: [],

                showpassword: false,
                oldShowpassword: false,
                newShowpassword: false,
                newShowpasswordConfirm: false,

                modelnewpassword1: '',
                modelnewpassword2: '',

                snackbar: {
                    newpassword1: false,
                    newpassword2: false
                },

                PassRequirementsMessages:
                {
                    newpassword1: [
                        { text: "MustContainLeast8Characters", satisfy: false, regx: /.{8,}/ },
                        { text: "MustContainLeastOneSpecialCharacter", satisfy: false, regx: /[!@#\$%\^\&*\)\(+=._-]/ },
                        { text: "MustContainLeastOneLowercaseLetter", satisfy: false, regx: /[a-z]/ },
                        { text: "MustContainLeastOneUppercaseLetter", satisfy: false, regx: /[A-Z]/ },
                        { text: "MustContainLeastOneNumber", satisfy: false, regx: /\d/ }
                    ],
                    newpassword2: [
                        { text: "MustContainLeast8Characters", satisfy: false, regx: /.{8,}/ },
                        { text: "MustContainLeastOneSpecialCharacter", satisfy: false, regx: /[!@#\$%\^\&*\)\(+=._-]/ },
                        { text: "MustContainLeastOneLowercaseLetter", satisfy: false, regx: /[a-z]/ },
                        { text: "MustContainLeastOneUppercaseLetter", satisfy: false, regx: /[A-Z]/ },
                        { text: "MustContainLeastOneNumber", satisfy: false, regx: /\d/ }
                    ]
                },

                pageInputs: {
                    'Login_Request': ['email', 'password', 'captcha'],
                    'Login_Verification': ['verificationcode'],
                    'Login_Change_Password': ['email', 'oldpassword', 'newpassword1', 'newpassword2']
                },

                documents: [
                    { selected: false, error: false, title: 'KVKK' }
                ],

                timeoutid: '',
                timerenable: false,
                timerremaining: 180,
                timerbase: 180,

                captchaBlur: true,
                captchaUrl: '',
            };
        },
        computed: {
            showErrorPopup: function ()
            {
                return this.errorMessages.length > 0;
            },
            LoginRequestButtonDisableState: function ()
            {
                return this.processing;
            }
        },
        methods: {
            OnDefaultEnter: function ()
            {
                const self = this;

                if (self.phase == 'request')
                {
                    self.Login_Request();
                }
                else if (self.phase == 'changePassword')
                {
                    self.Login_Change_Password();
                }
                else
                {
                    if (self.timerremaining == 0)
                    {
                        self.Login_Send_OTP();
                    }
                    else
                    {
                        self.Login_Verification();
                    }
                }
            },
            Login_Request: function ()
            {
                const self = this;

                if (self.ValidateBeforeAction('Login_Request'))
                {
                    self.processing = true;

                    const payload = {
                        phase: self.phaseHash,
                        captcha: self.model.captcha,
                        inputs: {
                            email: self.model.email,
                            password: self.model.password,
                            accesskey: self.accesskey
                        }
                    };

                    self.$store
                        .dispatch("AccountActionV2", { method: "Login", payload: payload })
                        .then(response =>
                        {
                            //self.phase = response.data.targetPhase;
                            self.phaseHash = response.data.targetPhaseHash;
                            self.accesskey = response.data.accessKey;
                            self.Login_Send_OTP();
                        })
                        .catch(errorResponse =>
                        {
                            self.errorMessages = errorResponse.data.errors.map(msg => self.$t(msg));

                            if (errorResponse.data.backToFirstPhase)
                            {
                                self.ReloadCaptcha();
                                self.ClearModel();
                            }

                            self.processing = false;
                        });
                }
            },

            Login_Send_OTP: function ()
            {
                const self = this;

                self.processing = true;

                const payload = {
                    phase: self.phaseHash,
                    captcha: self.model.captcha,
                    inputs: {
                        email: self.model.email,
                        password: self.model.password,
                        accesskey: self.accesskey
                    }
                };

                self.$store
                    .dispatch("AccountActionV2", { method: "Login", payload: payload })
                    .then(response =>
                    {
                        self.phase = response.data.targetPhase;
                        self.phaseHash = response.data.targetPhaseHash;
                        self.accesskey = response.data.accessKey;

                        self.model.verificationcode = response.data.data.otp || '';
                        self.eventid = response.data.data.token;
                        self.phonecode = response.data.data.phonecode;
                        self.maskedphonenumber = response.data.data.maskedphonenumber;

                        self.timerremaining = self.timerbase;
                        self.timerenable = true;

                        self.processing = false;
                    })
                    .catch(errorResponse =>
                    {
                        self.errorMessages = errorResponse.data.errors.map(msg => self.$t(msg));

                        if (errorResponse.data.backToFirstPhase)
                        {
                            self.timerenable = false;
                            self.ReloadCaptcha();
                            self.ClearModel();
                        }

                        self.processing = false;
                    });
            },

            Login_Verification: function ()
            {
                if (this.ValidateBeforeAction('Login_Verification'))
                {
                    const self = this;

                    self.processing = true;

                    const payload = {
                        phase: self.phaseHash,
                        captcha: self.model.captcha,
                        inputs: {
                            email: self.model.email,
                            password: self.model.password,
                            accesskey: self.accesskey,
                            token: self.eventid,
                            otp: self.model.verificationcode
                        }
                    };

                    self.$store
                        .dispatch("AccountActionV2", { method: "Login", payload: payload })
                        .then(response =>
                        {
                            if (response.data.mustChangePassword) {
                                self.phase = response.data.targetPhase;
                                self.phaseHash = response.data.targetPhaseHash;
                                self.accesskey = response.data.accessKey;
                                self.processing = false;
                            }
                            else {
                                self.$store.dispatch("GetUserInfo")
                                    .then(() => {
                                        self.$store.commit("SetUserLoggedIn", true);
                                        self.$store.dispatch("PushToRouter", "/");
                                    });
                            }
                            
                        })
                        .catch(errorResponse =>
                        {
                            self.errorMessages = errorResponse.data.errors.map(msg => self.$t(msg));

                            if (errorResponse.data.backToFirstPhase)
                            {
                                self.timerenable = false;
                                self.ReloadCaptcha();
                                self.ClearModel();
                            }

                            self.processing = false;
                        });
                }
            },

            Login_Change_Password: function () {
                if (this.ValidateBeforeAction('Login_Change_Password')) {

                    const self = this;

                    self.processing = true;

                    const payload = {
                        phase: self.phaseHash,
                        captcha: self.model.captcha,
                        inputs: {
                            email: self.model.email,
                            oldpassword: self.model.oldpassword,
                            newpassword1: self.model.newpassword1,
                            newpassword2: self.model.newpassword2,
                            accesskey: self.accesskey
                        }
                    };

                    self.$store
                        .dispatch("AccountActionV2", { method: "Login", payload: payload })
                        .then(response => {
                            self.$store.dispatch("GetUserInfo")
                                .then(() => {
                                    self.$store.commit("SetUserLoggedIn", true);
                                    self.ShowDialog(self.$root.$i18n.t('IM_PasswordChangedHomePage'), 'B', 'dialog', undefined, function () {
                                        self.PushToRouter({ name: 'home' });
                                    });
                                })
                                .catch(err => console.error("GetUserInfo hatası:", err));
                        })
                        .catch(errorResponse => {
                            self.errorMessages = errorResponse.data.errors.map(msg => self.$t(msg));

                            if (errorResponse.data.backToFirstPhase) {
                                self.timerenable = false;
                                self.ReloadCaptcha();
                                self.ClearModel();
                            }

                            self.processing = false;
                        });
                }
            },

            ValidateBeforeAction: function (action)
            {
                const self = this;

                self.ClearErrors();

                const inputs = self.pageInputs[action]

                for (var ctrl of self.pageInputs[action])
                {
                    var data = self.model[ctrl];

                    if (ctrl == 'email')
                    {
                        self.errors[ctrl] = (data == '');

                        if (!self.errors[ctrl])
                        {
                            var isEmailValidated = self.ValidateEmail(self.model.email);

                            self.errors[ctrl] = (!isEmailValidated);

                            if (!isEmailValidated)
                            {
                                self.errorMessages.push(self.$t('WarnEmailMustBeInRightFormat'));
                            }
                        }
                    }
                    else
                    {
                        self.errors[ctrl] = (data == '');
                    }
                }

                self.PrepareErrorMessage(self.pageInputs[action]);

                for (var document of self.documents)
                {
                    if (!document.selected)
                    {
                        document.error = true;
                        self.errorMessages.push(self.$t(document.title + 'ErrWarn'));
                    }
                }

                return !self.showErrorPopup;
            },

            PrepareErrorMessage: function (pageInputs)
            {
                var requiredErr = false;

                for (var err in this.errors)
                {
                    if (pageInputs.indexOf(err) > -1)
                    {
                        if (this.errors[err] == true)
                        {
                            if (this.model[err] == '') requiredErr = true;
                        }
                    }
                }

                if (!this.isAnyError)
                {
                    for (var document of this.documents)
                    {
                        if (document.error)
                        {
                            this.isAnyError = true;
                            break;
                        }
                    }
                }

                if (requiredErr)
                {
                    this.errorMessages.push(this.$t('WarnYouMustFillAllRequiredFields'));
                }
            },

            ValidateEmail: function (value)
            {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(value).toLowerCase());
            },

            ClearErrors: function (keepInputsCss)
            {
                this.errorMessages = [];

                if (keepInputsCss)
                {
                    return;
                }

                for (var document of this.documents)
                {
                    document.error = false;
                }

                for (var reset in this.errors)
                    this.errors[reset] = false;
            },

            ReloadCaptcha: function (mounted)
            {
                const self = this;

                self.model.captcha = '';
                self.captchaUrl = '';

                const rnd = Math.floor(new Date().getTime() / 1000).toString();

                axios
                    .get(`/api/Account/Captcha?rnd=${rnd}`, {
                        responseType: 'arraybuffer',
                    })
                    .then((response) =>
                    {
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const imageUrl = URL.createObjectURL(blob);
                        self.captchaUrl = imageUrl;

                        if (!mounted)
                        {
                            self.captchaBlur = false;
                        }
                    })
                    .catch((error) =>
                    {
                        self.errorMessages.push('TOO_MANY_REQUEST_TRY_AGAIN_LATER');
                    });
            },

            ClearModel()
            {
                this.accesskey = '';
                this.model.email = '';
                this.model.password = '';
                this.model.captcha = '1';
                this.model.oldpassword = '';
                this.model.newpassword1 = '';
                this.model.newpassword2 = '';
                this.phase = 'request';
                this.showpassword = false;
                this.oldShowpassword = false;
                this.newShowpassword = false;
                this.newShowpasswordConfirm = false;
                this.modelnewpassword1 = '';
                this.modelnewpassword2 = '';
                this.captchaBlur = true;
                this.eventid = '';

                for (var document of this.documents)
                {
                    document.selected = false;
                }
            },

            SetSnackbar(input, value) {
                this.snackbar[input] = value == 1;
            },
        },
        watch: {
            timerenable:
            {
                handler: function (val, oldVal)
                {
                    if (val)
                    {
                        this.timeoutid = setTimeout(() =>
                        {
                            this.timerremaining--;
                        }, 1000);
                    }
                },
                deep: true
            },
            timerremaining: {
                handler(value)
                {
                    if (value > 0 && this.timerenable)
                    {
                        clearTimeout(this.timeoutid);

                        this.timeoutid = setTimeout(() =>
                        {
                            this.timerremaining--;
                        }, 1000);
                    }

                    if (value == 0)
                    {
                        this.model.verificationcode = '';
                    }
                },
                deep: true
            },
            modelnewpassword1: function (newVal, oldVal) {
                this.model.newpassword1 = newVal;

                for (let requirement of this.PassRequirementsMessages.newpassword1) {
                    requirement.satisfy = requirement.regx.test(newVal);
                }
            },
            modelnewpassword2: function (newVal, oldVal) {
                this.model.newpassword2 = newVal;

                for (let requirement of this.PassRequirementsMessages.newpassword2) {
                    requirement.satisfy = requirement.regx.test(newVal);
                }
            },
        },
        mounted: function ()
        {
            this.ClearModel();
            this.ReloadCaptcha(true);
            window.scrollTo(0, 0);
        }
    }
</script>